import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetCurrencyConversionListPagingAndFilterRequest } from '../models/request/currencyConversion/GetCurrencyConversionListPagingAndFilterRequest';

export class CurrencyConversionService {
    static async getCurrencyConversionList(_date: string) {
        try {
            var inputObj = {
                date: _date
            };

            console.log('SERVICE CALL - getCurrencyConversionList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyConversion/getCurrencyConversionList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportCurrencyConversionList(inputObj: GetCurrencyConversionListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportCurrencyConversionList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyConversion/exportCurrencyConversionList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getActiveCurrencyConversions(_date: string | undefined = undefined) {
        try {
            var inputObj = {
                date: _date
            };

            console.log('SERVICE CALL - GetActiveCurrencyConversions', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyConversion/GetActiveCurrencyConversions', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCurrencyConversionListPagingAndFilter(inputObj: GetCurrencyConversionListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetCurrencyConversionListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyConversion/GetCurrencyConversionListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addCurrencyConversion(_currencyConversionId: string | undefined, _date: string, _realDate: string, _fromCurrencyId: string | undefined, _toCurrencyId: string | undefined, _buy: string, _sell: string) {
        try {
            var inputObj = {
                currencyConversionId: _currencyConversionId,
                date: _date,
                realDate: _realDate,
                fromCurrencyId: _fromCurrencyId,
                toCurrencyId: _toCurrencyId,
                buy: _buy,
                sell: _sell,
            };

            console.log('SERVICE CALL - AddCurrencyConversion', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyConversion/AddCurrencyConversion', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteCurrencyConversion(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteCurrencyConversion', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyConversion/deleteCurrencyConversion', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCurrencyConversionById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getCurrencyConversionById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CurrencyConversion/getCurrencyConversionById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}